import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ac9d54d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"14px","color":"#8c8c8c"} }, "M", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"14px","color":"#8c8c8c"} }, "张", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Upload = _resolveComponent("Upload")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form_item, {
      label: "示例图片",
      class: "imgItem"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Upload, {
          relativeUrl: _ctx.item.sampleImg,
          "onUpdate:relativeUrl": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.sampleImg) = $event)),
          absoluteUrl: _ctx.item.sampleImgUrl,
          "onUpdate:absoluteUrl": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.sampleImgUrl) = $event))
        }, null, 8, ["relativeUrl", "absoluteUrl"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_form_item, {
      class: "correct",
      label: "图片大小",
      name: "imgSize",
      rules: _ctx.imgSizeRules
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          style: {"width":"160px"},
          placeholder: "若不输入默认5M",
          value: _ctx.item.imgSize,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.imgSize) = $event)),
          valueModifiers: { trim: true },
          maxlength: 2,
          allowClear: "",
          size: "small"
        }, null, 8, ["value"]),
        _hoisted_1
      ]),
      _: 1
    }, 8, ["rules"]),
    (_ctx.item.itemType == 'multiplepictures')
      ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 0,
          class: "correct",
          label: "图片最大数量",
          name: "imgMaxCnt",
          rules: _ctx.imgMaxCntRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              style: {"width":"160px"},
              placeholder: "若不输入默认9张",
              value: _ctx.item.imgMaxCnt,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.imgMaxCnt) = $event)),
              valueModifiers: { trim: true },
              maxlength: 2,
              allowClear: "",
              size: "small"
            }, null, 8, ["value"]),
            _hoisted_2
          ]),
          _: 1
        }, 8, ["rules"]))
      : _createCommentVNode("", true)
  ], 64))
}